(function() {
  'use strict';

  angular.module('cfn').directive('dPageButtonDropdown', function() {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        iconCls: '@',
        btnLabel: '@',
        disabled: '='
      },
      templateUrl: require('./d-page-button-dropdown.html'),
      link: function(scope, el) {
        scope.toggleDropdown = function(e) {
          var dropdownDiv = el.children().first();
          if (scope.disabled) {
            return;
          }
          dropdownDiv.toggleClass('open');
        };
      }
    };
  });
})();
